/* eslint-disable @typescript-eslint/naming-convention */
import { type UseMutateFunction, useMutation } from '@tanstack/react-query';

import type { AIAssistantReplyFeedbackEvent } from 'services/connectivity/ml-gateway-api/event-collector/types';
import { eventCollectorClient } from 'services/connectivity/ml-gateway-api/event-collector/client';

type SendFeedbackEvent = {
  requestId: string;
};

type IUseSendFeedbackProps = {
  onSuccess: (payload: AIAssistantReplyFeedbackEvent) => void;
  onError: () => void;
};

type UseSendFeedbackEvent = {
  sendFeedbackEvent: UseMutateFunction<AIAssistantReplyFeedbackEvent, unknown, SendFeedbackEvent, unknown>;
};

export const useSendFeedbackEvent = ({ onSuccess, onError }: IUseSendFeedbackProps): UseSendFeedbackEvent => {
  const { mutate } = useMutation<AIAssistantReplyFeedbackEvent, unknown, SendFeedbackEvent>({
    mutationFn: async ({ requestId }: SendFeedbackEvent) => {
      const eventToSend: AIAssistantReplyFeedbackEvent = {
        project: 'live-assistant',
        type: 'feedback',
        request_id: requestId,
        template_version: '1.0.0',
        data: {
          version: '1.0.0',
          thumbsdown: true,
          negative_aspects: [],
        },
      };

      const { error } = await eventCollectorClient.sendEvent(eventToSend);

      if (error) {
        throw error;
      }

      return eventToSend;
    },
    onSuccess,
    onError,
  });

  return {
    sendFeedbackEvent: mutate,
  };
};
